
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"37","viewBox":"0 0 36 37","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18 3.5c-8.284 0-15 6.716-15 15 0 8.285 6.716 15 15 15 8.285 0 15-6.715 15-15 0-8.284-6.715-15-15-15zm8.56 11.56l-10.5 10.5a1.496 1.496 0 01-2.12 0l-4.5-4.5a1.498 1.498 0 010-2.12 1.498 1.498 0 012.12 0L15 22.378l9.44-9.44a1.498 1.498 0 012.12 0 1.498 1.498 0 010 2.121z","fill":"#fff"}})])
          )
        }
      }
    